import {noop} from 'lodash';
import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Dropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {SeparatorsEnum} from '../../../helpers/analyticsExportHelpers';
import {SeparatorConfig} from './exportSeparatorInput';

/*
 * Styles.
 */

export const StyledLabelDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.small};
  color: ${(p) => p.theme.greys.shade70};
  padding-bottom: 6px;
`;

export const PaddedGridItemDiv = styled.div`
  padding-bottom: 16px;
`;

const StyledDropdownItem = styled(DropdownItem)`
  width: 260px;
`;

/*
 * Constants.
 */

export enum MetricExportTypesEnum {
  CHART_DATA = 'chart_data',
  TABLE_DATA = 'table_data',
}

/** Separators are universal for CSVs, so we define them here */
export const separatorConfigs: ReadonlyArray<SeparatorConfig> = [
  {
    value: SeparatorsEnum.COMMA,
    title: <Trans id="analytics-separator-config-comma-title">{'Use ","'}</Trans>,
  },
  {
    value: SeparatorsEnum.SEMICOLON,
    title: <Trans id="analytics-separator-config-semicolon-title">{'Use ";"'}</Trans>,
  },
  {
    value: SeparatorsEnum.TAB,
    title: <Trans id="analytics-separator-config-tab-title">Use tab</Trans>,
  },
];

/*
 * Helpers.
 */

export function renderMultiSelectDropdown(
  popoverProps: PopoverTransferProps,
  availableRows: readonly string[],
  currentlySelectedRows: readonly string[],
  setRows: HandlerOf<readonly string[]>,
) {
  const onSelectKey = (key: string) => {
    const newColumns = new Set(currentlySelectedRows);

    if (newColumns.size > 1 && newColumns.has(key)) {
      newColumns.delete(key);
    } else {
      newColumns.add(key);
    }

    setRows([...newColumns]);
  };

  const items = availableRows.map((column) => {
    const isChecked = currentlySelectedRows.includes(column);

    return (
      <StyledDropdownItem key={column} isChecked={isChecked} onSelect={() => onSelectKey(column)}>
        <DropdownItemContent isChecked={isChecked}>{column}</DropdownItemContent>
      </StyledDropdownItem>
    );
  });

  return (
    <Dropdown {...popoverProps}>
      <DropdownList {...popoverProps} onRequestClose={noop}>
        {items}
      </DropdownList>
    </Dropdown>
  );
}
